import React from 'react';
import './Acomodacion.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import AcomodacionData from '../../Components/Admin/AcomodacionData/AcomodacionData';

export default function Acomodacion() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container mesas-container-custom'>
                    <AcomodacionData />
                </div>
            </section>
        </div>
    );
}

